export const getVisibilityTabId = (pathName: string | undefined) => {
  let tabId = 'devices';
  if (pathName && pathName.includes('prism')) {
    tabId = 'prism';
  } else if (pathName && pathName.includes('pulse')) {
    tabId = 'pulse';
  }
  return tabId;
};
